import { render, staticRenderFns } from "./EditOpportunityLabelDialog.vue?vue&type=template&id=7f73fe5c"
import script from "./EditOpportunityLabelDialog.vue?vue&type=script&lang=js"
export * from "./EditOpportunityLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./EditOpportunityLabelDialog.vue?vue&type=style&index=0&id=7f73fe5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports